export default __webpack_public_path__ + "static/media/grid-icon.eda629f3.svg";